import { createContext, useContext, useEffect, useState } from "react";

import { SessionContext } from "@context/session.context";
import { services } from "@src/dependencies";
import { useApiRequest } from "@utils/http-client";
import { sortObjectArrayByKey } from "@utils/utils";

export const MenuBuilderContext = createContext({});

export default ({ children }) => {
  const [menus, setMenus] = useState();
  const [categories, setAllCategories] = useState();
  const [modules, setModules] = useState();

  const { menuBuilderService } = services;
  const { currentUser } = useContext(SessionContext);

  useEffect(() => {
    if (currentUser) {
      setMenus([]);
      getAllCategories();
      getAllModules();
    }
  }, [currentUser]);

  const { loading, sendRequest: getAllModules } = useApiRequest(
    () =>
      menuBuilderService
        .getAllModules()
        .then((response) => setModules(sortObjectArrayByKey(response, "name")))
        .catch((error) => {
          console.error("ERROR:", error);
          return;
        }),
    false,
  );

  const { loading: loadingCategories, sendRequest: getAllCategories } =
    useApiRequest(
      () =>
        menuBuilderService
          .getTemplateCategories(false)
          .then((response) => {
            setAllCategories(sortObjectArrayByKey(response, "name"));
          })
          .catch((error) => {
            console.error("ERROR:", error);
            return;
          }),
      false,
    );

  const contextValue = {
    currentUser,
    modules,
    menus,
    categories,
    loadingAllCategories: loadingCategories,
    loadingAllModules: loading,
    getAllCategories: getAllCategories,
    getAllModules: getAllModules,
  };

  return (
    <MenuBuilderContext.Provider value={contextValue}>
      {children}
    </MenuBuilderContext.Provider>
  );
};
